import { createShapeId, StateNode, TLEventHandlers } from '@bigbluebutton/tldraw';

export default class GridTool extends StateNode {
  static override id = 'grid-tool';

  override onEnter = () => {
    this.editor.setCursor({ type: "cross" }); // ✅ Change cursor to crosshair
  };

  override onExit = () => {
    this.editor.setCursor({ type: "default" }); // ✅ Restore default cursor
  };

  override onPointerDown: TLEventHandlers['onPointerDown'] = (event) => {

    const { editor } = this;
    if (!editor) return;

    const currentUser = editor.user || { id: "unknown" };
    // const x = event.point.x;
    // const y = event.point.y;
    // ✅ Convert screen point to canvas coordinates
    const { x, y } = editor.screenToPage(event.point);

    const shapeId = createShapeId(); // Generates a valid TLShapeId
    editor.createShape({
      id: shapeId,
      type: "graphgrid",
      props: { w: 500, h: 500, rows: 50, cols: 50 },
      x,
      y,
      meta: { createdBy: 'userid' },
    });

    setTimeout(() => {
      editor.setCurrentTool("select");
    }, 100);


    this.parent.transition('draw');
  };
}
